// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import { FormHelperText, Input, InputLabel} from "@mui/material";

// App Imports
import {addBatch, editBatch} from "./BatchClient";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";


// Main Function
export default function BatchDrawer({batchDrawerState,batchDrawerMode,fetchBatchs}) {


    // ****************** BEGIN STATES ****************************

    const [showBatchDrawer, setShowBatchDrawer] = React.useState(false);
    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const dispatchData = useDispatch() ;
    const selectorBatchId = useSelector((state) => state.batchSlc.value.id);

    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const {register, handleSubmit} = useForm();

    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        // setBatchId(props.batchIdX)
        console.log("here's my batch data")
        console.log({data})
        console.log("here's my stringify data")
        console.log(JSON.stringify(data, null, 2))
        if(batchDrawerMode==="Add"){
            addBatch(data)
                .then(() => {
                    console.log("Batch added");
                    fetchBatchs();
                }).catch(err => {
                console.log(err)
            }).finally(() =>{
                setSubmitting(false);
                setShowBatchDrawer(false);
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
            })}
        if(batchDrawerMode==="Edit"){
            console.log("This is the batch Id I am going to edit")
            console.log(selectorBatchId)
            // editBatch(selectorBatchId, {'type', 'started', 'description'})
            editBatch(selectorBatchId, data)
                .then(() => {
                    console.log("Batch edited")
                    fetchBatchs();
                }).catch(err => {
                console.log(err)
                console.log("Dammit!")
            }).finally(() =>{
                setSubmitting(false);
                setShowBatchDrawer(false);
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
            })}
    };

    // ****************** END CRUD ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect( () =>{
        if(
            batchDrawerState !== showBatchDrawer)
        {setShowBatchDrawer(!showBatchDrawer);
            console.log("Drawer State Changing")
        }
    }, [batchDrawerState]);

    // ******************** END USE EFFECTS *******************


    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };


    function openBatchDrawer() {
        setShowBatchDrawer(true);
    };

    function closeBatchDrawer() {
        setShowBatchDrawer(false);
    };

    // ****************** END MISC ****************************


    // ****************** BEGIN FORM ****************************

    function batchForm(){
        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >

                <Box
                    sx={{ width: 800 , height: 300, pl: 5}}
                    role="presentation"
                >
                    <h1 onClick={() => closeBatchDrawer()}>Data Point  Form</h1>
                    <h4>{batchDrawerMode} Mode</h4>
                    <br/>
                    <br/>
                    <br/>
                    <InputLabel htmlFor="type">Type</InputLabel>
                    <Input
                        {...register('type', { required: true })}
                        id="type" started="type"  label="type" aria-describedby="type_entry"
                        defaultValue=        {useSelector((state) => state.batchSlc.value.type)}
                    />
                    <FormHelperText id="type_helper">enter a brief code in all caps</FormHelperText>
                    <br/>
                    <br/>
                    <br/>
                    <InputLabel htmlFor="started">Started</InputLabel>
                    <Input
                        {...register('started', { required: true })}
                        id="started"   started="started"  label="Started" aria-describedby="started_entry"
                        defaultValue=        {useSelector((state) => state.batchSlc.value.started)}
                        sx={{ width: 600 }} />
                    <FormHelperText id="started_helper">enter the started of the Data Point</FormHelperText>
                    <br/>
                    <br/>
                    <Button
                        type= "submit"
                    >Submit</Button>
                    <Button onClick={() => closeBatchDrawer()}>Cancel</Button>
                </Box>
            </form>
        );}

    // ****************** END FORM ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={showBatchDrawer}
                initialState={{open: false}}
                onClose={closeBatchDrawer}
            >
                {batchForm()}
            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
